'use client'

import { motion } from 'framer-motion'
import { MoreVertical } from 'lucide-react'

export default function ReturnStatus() {
  const statusData = [
    { label: 'Due date' },
    { label: 'Return filed on' },
    { label: 'Return verified on' }
  ]

  return (
    <div className="bg-white rounded-lg shadow-sm p-6" style={{borderRadius:'10px'}}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-medium text-gray-800">Return Filing Status</h3>
        <button>
          <MoreVertical className="w-5 h-5 text-gray-400" />
        </button>
      </div>
      
      <div className="space-y-4">
        {statusData.map((item, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.3, delay: index * 0.1 }}
            className="flex items-center justify-between"
          >
            <span className="text-gray-600 text-[14px]">{item.label}</span>
            <span className="text-gray-400 text-[14px]">-</span>
          </motion.div>
        ))}
      </div>
    </div>
  )
}

